import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Accordion, AccordionSize } from 'wix-ui-tpa/cssVars';
import { useApplicationContext } from '../../../../../core/hooks/useApplicationContext';
import { useGroupHeaderGetters } from '../../../../../core/hooks/useGroupHeaderGetter';
import { TabTypes } from '../../../../../types';
import { BookingsListDataHooks } from '../../datahooks';
import { renderBookingDetails } from './BookingDetails';
import { classes, st } from './BookingsList.st.css';

export const BookingsList: FC = () => {
  const { upcomingData, historyData, selectedTab, environmentModes } =
    useApplicationContext();
  const { t } = useTranslation();
  const { isMobile, isRTL } = useEnvironment();
  const { getTitle, getSubtitle } = useGroupHeaderGetters();
  let initiallyExpanded = '';

  const data =
    selectedTab.type === TabTypes.UPCOMING ? upcomingData : historyData;

  const dataToShow = data?.groups || [];

  if (environmentModes.isEditorMode) {
    initiallyExpanded = dataToShow[1]?.groupId || '';
  }

  return (
    <div className={classes.root} data-hook={BookingsListDataHooks.Main}>
      <Accordion
        className={st(classes.accordion, { isMobile })}
        data-hook={BookingsListDataHooks.Accordion}
        initiallyExpanded={initiallyExpanded}
        size={AccordionSize.Large}
        aria-label={t(
          'app.my-bookings-widget.bookings-list.accordion.aria-label',
        )}
      >
        {dataToShow.map((group, index) =>
          renderBookingDetails({
            group,
            t,
            isMobile,
            isRTL,
            selectedTab,
            title: getTitle(group),
            subtitle: getSubtitle(group),
            isManageButtonOpen:
              environmentModes.isEditorMode && index === 0 && !isMobile,
          }),
        )}
      </Accordion>
    </div>
  );
};
